import { META } from "@/content/meta";
import { usePageMeta } from "@/hooks/usePageMeta";
import { PageHero } from "@/components/site/PageHero";
import { CTAButton } from "@/components/site/CTAButton";

export default function NotFound() {
  usePageMeta(META.notFound);
  return (
    <PageHero eyebrow="404" lines={["This page took", "a wrong turn."]} copy="The page you're looking for doesn't exist." testId="not-found">
      <div className="mt-10">
        <CTAButton to="/" testId="not-found-home-button">
          Back to home
        </CTAButton>
      </div>
    </PageHero>
  );
}
